import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, {
  parseFractionLikeInput as parseFraction,
  formatLatexPreview,
} from "../../../../components/inputs/FractionInput";

const DEC_TOL = 0.01;
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export function generateTask() {
  const A = Array.from({ length: 18 }, (_, i) => i + 3); // 3..20
  // D1 i D2 parzyste dla ładnych wyników po połowie
  const D = Array.from({ length: 9 }, (_, i) => 2 * (i + 2)); // 4..20
  const d1 = pick(D), d2 = pick(D);
  const P = 0.5 * d1 * d2;
  return { type: "RhombusAreaFromDiagonalsTask", data: { d1, d2, P } };
}

export function renderTask({ data }) {
  const { d1, d2 } = data;
  return (
    <div style={{ marginTop: 8, marginBottom: 8 }}>
      Dany jest romb o przekątnych <InlineMath math={'d_1='+d1} /> i <InlineMath math={'d_2='+d2} />.
      Oblicz jego pole <InlineMath math={'P'} />.
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  const normalize = (v) => (typeof v === "string" ? v : v?.raw ?? "");
  return (
    <FractionInput
      value={raw}
      onChange={(v) => onChange({ raw: normalize(v) })}
      disabled={disabled}
      label="P"
      placeholder="np. 72"
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return false;
  const val = parseFraction(raw);
  return Number.isFinite(val) && Math.abs(val - data.P) <= DEC_TOL;
}

export const renderAnswer = ({ data }) => <InlineMath math={'P='+data.P} />;

export function renderExplanation({ data }) {
  const { d1, d2, P } = data;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <strong>Krok 1.</strong> Wzór na pole rombu: <InlineMath math={'P=\\tfrac{1}{2}d_1d_2'} />.
      <BlockMath math={`P=\\tfrac{1}{2}\\cdot ${d1}\\cdot ${d2}=${P}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={formatLatexPreview(raw, 'P')} />;
}

export default {
  generateTask,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};